import { render, staticRenderFns } from "./sellerCustomer.vue?vue&type=template&id=09ec2ea4&scoped=true"
import script from "./sellerCustomer.vue?vue&type=script&lang=js"
export * from "./sellerCustomer.vue?vue&type=script&lang=js"
import style1 from "./sellerCustomer.vue?vue&type=style&index=1&id=09ec2ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec2ea4",
  null
  
)

export default component.exports